const ALLOWED_TAGS = new Set([
  'p',
  'br',
  'strong',
  'em',
  'ul',
  'ol',
  'li',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'blockquote'
]);

function escapeHTML(value) {
  return String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

function sanitizeElement(node, doc) {
  for (const child of [...node.childNodes]) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      const tag = child.tagName.toLowerCase();
      if (!ALLOWED_TAGS.has(tag)) {
        const text = doc.createTextNode(child.textContent || '');
        child.replaceWith(text);
        continue;
      }
      for (const attr of [...child.attributes]) {
        child.removeAttribute(attr.name);
      }
      sanitizeElement(child, doc);
      continue;
    }

    if (child.nodeType === Node.COMMENT_NODE) {
      child.remove();
    }
  }
}

// Defense-in-depth sanitizer for CMS HTML. The server (sanitizeCMSContent) is the
// authoritative pass; this re-sanitizes before rendering via dangerouslySetInnerHTML.
// Content is parsed directly into a document body (never wrapped in an element,
// which a crafted "</div>" could break out of) and only allowlisted, attribute-less
// tags survive.
export function sanitizeCmsHtml(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';

  if (typeof DOMParser === 'undefined') {
    return escapeHTML(raw).replaceAll('\n', '<br>');
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(raw, 'text/html');
  const body = doc.body;
  if (!body) return '';
  sanitizeElement(body, doc);
  return body.innerHTML;
}
